import { render, staticRenderFns } from "./FPotensIKawasanTelekomunikasi.vue?vue&type=template&id=37b59777&scoped=true"
import script from "./FPotensIKawasanTelekomunikasi.vue?vue&type=script&lang=js"
export * from "./FPotensIKawasanTelekomunikasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b59777",
  null
  
)

export default component.exports